export default "__VITE_ASSET__0GFXFeP1__"